// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__WofTg","modal":"Modal_modal__X2U+F","slide-down":"Modal_slide-down__IAkRw"};